import { Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Loader } from "@/pages/SignInPage/components/molecules/Loader"

import styles from "./SsoPopupSigningIn.module.scss"

// Shown by a Kodem SSO popup while it exchanges the handoff token, until it closes itself
export const SsoPopupSigningIn = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "auth.ssoPopupSigningIn"
  })

  return (
    <div
      data-testid="ssoPopupSigningIn"
      role="status"
      aria-live="polite"
      className={styles.container}
    >
      <Loader />
      <Text>{t("text")}</Text>
    </div>
  )
}
